 /**
  * 描述：新增媒体
  * 日期：2018-12-06
  * 作者：Qian.qianchen
  */
 "use strict";
 angular.module("addPapersiteModule", [])
     .controller("addPapersiteCtrl", ["$scope", "$sce", "$modalInstance", "$q", "$stateParams", "trsHttpService", "modalDialog", function($scope, $sce, $modalInstance, $q, $stateParams, trsHttpService, modalDialog) {
         initStatus();
         initData();

         /**
          * [initStatus description]初始化状态
          */
         function initStatus() {
             $scope.status = {

             };
             $scope.data = {
                 keywords: '',
                 papersiteArray: [],
                 papersiteSelectedArray: [],
                 chosenArray: []
             };
         }

         /**
          * [cancel description] 关闭弹窗
          * @return {[type]} [description]
          */
         $scope.cancel = function() {
             $modalInstance.dismiss();
         };

         /**
          * [initData description] 媒体数据初始化
          * @return {[type]} [description]
          */
         function initData() {
             getPapersite();
             getSelectedPapersite();
         }
         /**
          * [getPapersite description] 获取媒体
          * @param  {[type]} name [description]媒体名称（可选）
          * @return {[type]}      [description]
          */
         function getPapersite() {
             var deffer = $q.defer();
             var searchValue = '';
             var params = {
                 serviceid: "mlf_website",
                 methodname: "queryPaperSites",
                 searchValue: $scope.data.keywords
             }
             trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                 $scope.data.papersiteArray = [];
                 for (var i = 0; i < data.length; i++) {
                     $scope.data.papersiteArray.push({
                         siteid: data[i].SITEID,
                         sitedesc: data[i].SITEDESC
                     });
                 }
                 deffer.resolve();
             });
             return deffer.promise;
         }
         /**
          * [getSelectedPapersite description] 获取用户已勾选媒体
          * @return {[type]} [description]
          */
         function getSelectedPapersite() {
             var deffer = $q.defer();
             var params = {
                 serviceid: "mlf_tenant",
                 methodname: "tenantChoosenSites"
             }
             trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                 for (var i = 0; i < data.length; i++) {
                     $scope.data.papersiteSelectedArray.push({
                         siteid: data[i].WEBSITEID,
                         sitedesc: data[i].WEBSITEDESC
                     });
                 }
                 deffer.resolve();
             });
             return deffer.promise;
         }
         /**
          * [objEqual description] 对象匹配
          * @param  {[Object]} obj1 [description] 对象1
          * @param  {[Object]} obj2 [description] 对象2
          * @return {[type]}      [description]
          */
         function objEqual(obj1, obj2) {
             var result = true;
             for (var k in obj1) {
                 if (obj1[k] != obj2[k]) {
                     result = false;
                     break;
                 }
             }
             return result;
         }

         function objIndexOf(arr, obj) {
          var index = -1;
             for (var i = 0; i < arr.length; i++) {
                 if (objEqual(arr[i], obj)) {
                     index = i;
                 }
             }
             return index;
         }
         /**
          * [checkStatus description] 多选框是否选中
          * @param  {[type]} item [description] 媒体对象
          * @return {[type]}      [description]
          */
         $scope.checkStatus = function(item) {
             if ((objIndexOf($scope.data.chosenArray, item) >= 0 && $scope.data.chosenArray.length > 0) || (objIndexOf($scope.data.papersiteSelectedArray,item) >= 0 && $scope.data.papersiteSelectedArray.length > 0)) {
                 return true;
             } else {
                 return false;
             }
         }
         /**
          * [disabledStatus description] 多选框是否可选状态
          * @param  {[type]} item [description] 媒体对象
          * @return {[type]}      [description]
          */
         $scope.disabledStatus = function(item) {
             if ((objIndexOf($scope.data.papersiteSelectedArray,item) >= 0 && $scope.data.papersiteSelectedArray.length > 0)) {
                 return true;
             } else {
                 return false;
             }
         }
         /**
          * [selectItem description] 选择媒体
          * @param  {[type]} item [description]媒体item
          * @return {[type]}      [description]
          */
         $scope.selectItem = function(item) {
             if (objIndexOf($scope.data.chosenArray,item) < 0)
                 $scope.data.chosenArray.push(item);
             else
                 $scope.data.chosenArray.splice(objIndexOf($scope.data.chosenArray,item), 1);
         }
         /**
          * [selectAll description] 媒体全选
          * @return {[type]} [description]
          */
         $scope.selectAll = function() {
             $scope.data.chosenArray = $scope.data.chosenArray.length === ($scope.data.papersiteArray.length - $scope.data.papersiteSelectedArray.length) ? [] : (function() {
                 var array = [];
                 for (var i = 0; i < $scope.data.papersiteArray.length; i++) {
                     if (objIndexOf($scope.data.papersiteSelectedArray,$scope.data.papersiteArray[i]) < 0) {
                         array.push($scope.data.papersiteArray[i]);
                     }

                 }
                 return array;
             })();
         }
         /**
          * [papersiteSearch description] 媒体搜索
          * @param  {[type]} ev [description]event
          * @return {[type]}    [description]
          */
         $scope.papersiteSearch = function(ev) {
             if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                 getPapersite();
             }
         }
         /**
          * [confirm description] 提交
          * @return {[type]} [description]
          */
         $scope.confirm = function() {
             var deffer = $q.defer();
             if ($scope.data.chosenArray.length > 0) {
                 var selectedStr = $scope.data.chosenArray[0].siteid;
                 for (var i = 1; i < $scope.data.chosenArray.length; i++) {
                     selectedStr = selectedStr + ',' + $scope.data.chosenArray[i].siteid;
                 }
                 var params = {
                     serviceid: "mlf_tenant",
                     methodname: "addPaperSiteWhitelist",
                     PAPERSITEIDS: selectedStr
                 }
                 trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                     modalDialog.alertType('保存成功', "", "success", false, function() {
                         $modalInstance.close();
                     });
                     deffer.resolve();
                 });
             } else {
                 modalDialog.alertType("未选择媒体！", "", "info", false, function() {
                     $modalInstance.close();
                 });
             }

             return deffer.promise;
         }
         $scope.selectAllStatus = function() {
             if ($scope.data.papersiteArray.length > 0 && ($scope.data.papersiteArray.length == ($scope.data.papersiteSelectedArray.length + $scope.data.chosenArray.length))) {
                 return true;
             } else {
                 return false;
             }
         }
     }]);